export class SortHelper {
    static naturalSortArrayOfObject<T extends Record<string, any>>(arr: T[], key: string): T[] {
        return arr.sort((a, b) => {
            const re = /(\d+|\D+)/g;

            const aParts = String(a[key]).match(re);
            const bParts = String(b[key]).match(re);

            // If either aParts or bParts are null, consider them as empty arrays
            if (aParts === null || bParts === null) {
                return (aParts === null ? 0 : 1) - (bParts === null ? 0 : 1);
            }

            for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
                const aPart = aParts[i];
                const bPart = bParts[i];

                // If one part is undefined, the shorter string comes first
                if (aPart === undefined) {
                    return -1;
                }
                if (bPart === undefined) {
                    return 1;
                }

                // Compare numeric parts numerically
                if (!isNaN(Number(aPart)) && !isNaN(Number(bPart))) {
                    const diff = parseInt(aPart, 10) - parseInt(bPart, 10);
                    if (diff !== 0) {
                        return diff;
                    }
                }

                // Compare non-numeric parts lexicographically
                if (aPart !== bPart) {
                    return aPart.localeCompare(bPart);
                }
            }

            return 0;
        });
    }
}
